import React, { useContext } from "react";
import Checkbox from "@mui/material/Checkbox";
import { FormControlLabel } from "@mui/material";
import { ModuleContext } from "../utils/Constants";
import { useSelector } from "react-redux";
import { isComponentDisabled, isComponentVisible } from "../utils/SaitUtils";

export default function SaitCheckbox(props) {
	const { afterChange, value, customFilter, ...checkboxProps } = props;

	const componentModule = useContext(ModuleContext);
	const objModArray = useSelector((state) => state["auth"]["objMod"]);
	const objMod = objModArray.find((objModObject) => objModObject.moduleName === componentModule && objModObject.idObject === props.objmod);

	const handleOnChange = () => {
		let newValue;
		if (props.value === "Y") {
			newValue = "N";
		} else if (props.value === "N" || props.value === "" || props.value === null || props.value === undefined) {
			newValue = "Y";
		} else {
			newValue = !props.value;
		}
		props.onChange(newValue);
	};
	return isComponentVisible(objMod, checkboxProps.hidden) ? (
		<FormControlLabel
			{...checkboxProps}
			disabled={isComponentDisabled(objMod, checkboxProps.disabled)}
			control={<Checkbox />}
			checked={props.value === true || props.value === "Y"}
			onChange={handleOnChange}
			sx={{
				width: props.width ? props.width : "auto",
			}}
		/>
	) : null;
}
